import EcoCartEmpty from './comps/EcoCartEmpty';
import './index.scss';
import useEcoCart from './useEcoCart';
import { useEffect, useState } from 'react';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartCss } from './type.d';
import EcoCartItems from './comps/EcoCartItems';
import EcoCartFooter from './comps/EcoCartFooter';
import getLocal from 'eco-design-reliance/getLocal';
import EcoCartAIRecommand from './comps/EcoCartAIRecommand';
import EcoCartHeader from './comps/EcoCartHeader';

const EcoCart: React.FC = () => {
    const { locale = '' } = getLocal();
    const { open = false, items = [], isLogin } = useEcoCart();
    const [visible, setVisible] = useState<boolean>(false);
    const [css, setCss] = useState<ItfEcoCartCss>({ ai: 0, footer: 0 });

    const handleCloseCart = () => {
        setVisible(false);
        setTimeout(() => {
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_OPEN, false);
        }, 600);
    };

    useEffect(() => {
        if (open) {
            setVisible(open);
        } else {
            const timer = setTimeout(() => {
                setVisible(false);
            }, 600);
            return () => {
                clearTimeout(timer);
            };
        }
    }, [open]);

    // 获取登录态
    useEffect(() => {
        if (typeof window !== 'undefined') {
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ISLOGIN);
        }
    }, []);

    // 初始化购物车
    useEffect(() => {
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_QUERY, locale);
    }, [locale]);

    // 登录后，购物车变化重新请求用户 coupon / gift cart
    useEffect(() => {
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_COUPON, items, isLogin, locale);
    }, [JSON.stringify(items), isLogin, locale]);

    return (
        <>
            {open && (
                <section className="eco-cart">
                    <div className={`eco-cart-content ${visible ? 'visible' : 'invisible'}`}>
                        {/* 购物车Header */}
                        <EcoCartHeader callback={handleCloseCart} />
                        {/* 购物车Body */}
                        <div className="eco-cart-body" style={{ maxHeight: `calc(100% - 60px - ${css.ai + css.footer}px)` }}>
                            {items?.length <= 0 ? <EcoCartEmpty /> : <EcoCartItems />}
                        </div>
                        {/* AI推荐 */}
                        <EcoCartAIRecommand callback={(h: number) => setCss((prev: ItfEcoCartCss) => ({ ...prev, ai: h }))} />
                        {/* 购物车Footer */}
                        {items?.length > 0 && (
                            <EcoCartFooter hasAI={css?.ai > 0} callback={(h: number) => setCss((prev: ItfEcoCartCss) => ({ ...prev, footer: h }))} />
                        )}
                    </div>
                </section>
            )}
        </>
    );
};

export default EcoCart;
